module.exports = __webpack_public_path__ + "static/assets/ff2dc3c9ffca9e8097e82e3ff64b5955.png";